import {
  forwardRef,
  useEffect,
  useRef,
  useState,
  useMemo,
  useImperativeHandle,
} from "react";
import { useSelector, useDispatch } from "react-redux";
import Alert from "../../../Controls/Alerts/Alerts";
import APIRequest from "../../../../Services/commonAPIConsumer";
import {
  languageChange,
  retainConfiguredData,
  currentSelectedLanguage,
} from "../../../../StateManagement/actions";

const Readers = forwardRef(function Readers(
  {
    readers,
    documentID,
    isAddToReaders,
    onAddReader,
    onToggle,
    onShowAddReader,

    isEdits,
    enableOptionsBasedOnLevelOne,
    isFromManage
  },
  ref
) {
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const [alertMsg, setAlertMsg] = useState("");
  const [alertType, setAlertType] = useState("");
  const addReaderRef = useRef();
  //const [checkReaders, setCheckReaders] = useState([]);
  const selectedLanguage = useSelector(currentSelectedLanguage);
  const data = useSelector((state) => state.pageLevelRestriction);
  const [addReader, setAddReader] = useState(false);
  const [selectedOption, setSelectedOption] = useState({
    noReaders: false,
    selectedReaders: false,
    everyOneExceptSelected: false,
  });
  //const [selectAll, setSelectAll] = useState(false);

  const selectedReaderInputRef = useRef([]);
  const selectAllRef = useRef(false);
  const checkReaders = useRef([]);
  // let results = readers.filter((reader) =>
  //   JSON.stringify(reader).toLowerCase().includes(search.toLowerCase())
  // );

  const results = useMemo(() => {
    let allReaders = readers;
    if (
      !isFromManage &&
      data.authorizedReaders.length > 0 &&
      readers.length !== data.authorizedReaders.length
    ) {
      allReaders = data.authorizedReaders.map((reader) =>
        Array.isArray(reader) ? reader[0] : reader
      );
    }
    return allReaders.filter((reader) =>
      JSON.stringify(reader).toLowerCase().includes(search.toLowerCase())
    );
  }, [search, readers]);

  useEffect(() => {
    if (isAddToReaders && addReaderRef.current) addReaderRef.current.focus();
    setAddReader(isAddToReaders);
    //checkReaders.current = [];
  }, [isAddToReaders, readers]);
  useEffect(() => {
    if (addReaderRef.current) {
      addReaderRef.current.focus();
    }
  }, [addReader]);
  const CancelClick = () => {
    setAddReader(false);
    onAddReader(false);
  };

  function EnterClick(e) {
    handleUserInput(true);
  }
  const AddReaderClick = () => {
    setAddReader(true);
  };
  const handleUserInput = async (e) => {
    if (e.key === "Enter" || e === true) {
      const emailInput = addReaderRef.current.value.trim();

      if (emailInput === "") {
        setAlertMsg(selectedLanguage.LstLanguageCodes.UI_Pleaseentervalidmail);
        setAlertType("warning");
        return;
      }
      const emailToCheck = emailInput.toLowerCase();
      const emailExists = readers
        .filter((email) => email !== null)
        .some((email) => email.toLowerCase() === emailToCheck);

      if (emailExists) {
        setAlertMsg(
          selectedLanguage.LstLanguageCodes.UI_DuplicateEmailNotallowed
        );
        setAlertType("warning");
        return;
      }
      // **Ensure email contains exactly one "@"**
      const atSymbolCount = emailInput.split("@").length - 1;
      if (atSymbolCount !== 1) {
        setAlertMsg(selectedLanguage.LstLanguageCodes.UI_Pleaseentervalidmail);
        setAlertType("warning");
        return;
      }
      // **Validate email format with regex**
      if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(emailInput)) {
        setAlertMsg(selectedLanguage.LstLanguageCodes.UI_Pleaseentervalidmail);
        setAlertType("warning");
        return;
      }
      const [localPart, domainPart] = emailInput.split("@");
      if (emailInput.length > 255) {
        setAlertMsg(
          selectedLanguage.LstLanguageCodes.UI_EmailmustbelessthanNum
        );
        setAlertType("warning");
        return;
      }

      if (localPart.length > 64) {
        setAlertMsg(
          selectedLanguage.LstLanguageCodes.UI_LocalpartmustbelessthaNum
        );
        setAlertType("warning");
        return;
      }

      if (domainPart.length > 190) {
        setAlertMsg(
          selectedLanguage.LstLanguageCodes.UI_ThedomainmustbelessthanNum
        );
        setAlertType("warning");
        return;
      }

      // **Proceed with adding the email**
      readers = [...readers, emailInput];
      if (!isFromManage) {
        const filteredReaders = readers
          .filter(
            (reader) =>
              !data.authorizedReaders.some(
                (authorizedReader) => authorizedReader[0] === reader
              )
          )
          .map((reader) => [reader, "", "", [], ""]);

        dispatch(
          retainConfiguredData({
            isConfirm: true,
            pageRestrictionData: data.pageLevelRestrictionData,
            authorizedReaders: [...data.authorizedReaders, ...filteredReaders],
          })
        );
      }

      setAddReader(false);
      onToggle(readers);
    }
  };

  // useEffect(() => {
  //   setTimeout(() => {
  //     setAlertMsg("");
  //     setAlertType("");
  //   }, 5000);
  // }, [alertType]);
  const onSearchHandler = (event) => {
    setSearch(event.target.value);
  };
  const handleSelectAll = (e) => {
    // setSelectAll(e.target.checked);
    // selectAllRef.current.checked=
    selectedReaderInputRef.current.map((item) => {
      if (item) item.checked = e.target.checked;
    });
    const selectedReaders = selectedReaderInputRef.current
      .filter(
        (element) => element && element.checked && readers.includes(element.id)
      )
      .map((element) => element.id);
    const unSelectedReaders = selectedReaderInputRef.current
      .filter(
        (element) => element && !element.checked && readers.includes(element.id)
      )
      .map((element) => element.id);
    const filteredSelectedRecords = checkReaders.current.filter(
      (element) => !unSelectedReaders.includes(element)
    );
    // setCheckReaders((prev) => {
    //   const filtered = selectedReaders.filter(
    //     (reader) => !prev.includes(reader)
    //   );
    //   return [...filtered, ...filteredSelectedRecords];
    // });
    const filtered = selectedReaders.filter(
      (reader) => !checkReaders.current.includes(reader)
    );
    checkReaders.current = [...filtered, ...filteredSelectedRecords];
  };
  const handleSelectReader = (e) => {
    let flag = true;
    selectedReaderInputRef.current = selectedReaderInputRef.current.filter(
      (ele) => ele != null
    );
    selectedReaderInputRef.current.map(
      (item) => (flag = flag ? item.checked : flag)
    );
    if (!flag) {
      // setSelectAll(false);
      selectAllRef.current.checked = false;
    } else {
      // setSelectAll(true);
      selectAllRef.current.checked = true;
    }
    const selectedReaders = selectedReaderInputRef.current
      .filter(
        (element) => element && element.checked && readers.includes(element.id)
      )
      .map((element) => element.id);
    const unSelectedReaders = selectedReaderInputRef.current
      .filter(
        (element) => element && !element.checked && readers.includes(element.id)
      )
      .map((element) => element.id);
    const filteredSelectedRecords = checkReaders.current.filter(
      (element) => !unSelectedReaders.includes(element)
    );
    // setCheckReaders((prev) => {
    //   const filtered = selectedReaders.filter(
    //     (reader) => !prev.includes(reader)
    //   );
    //   return [...filtered, ...filteredSelectedRecords];
    // });
    const filtered = selectedReaders.filter(
      (reader) => !checkReaders.current.includes(reader)
    );
    checkReaders.current = [...filtered, ...filteredSelectedRecords];
  };
  // useEffect(() => {
  // setSelectAll(false);
  // if (isEdits) {
  //   let isNoReadersSelected = false;
  //   let isSelectedReadersSelected = false;
  //   let isEveryOneExceptSelectedSelected = false;
  //   if (selectedCategory === "No Readers") {
  //     isNoReadersSelected = true;
  //     onShowAddReader(false, selectedCategory);
  //   } else if (selectedCategory === "Selected Readers") {
  //     isSelectedReadersSelected = true;
  //   } else {
  //     isEveryOneExceptSelectedSelected = true;
  //   }
  //   onShowAddReader(true, selectedCategory);
  //   setSelectedOption(() => {
  //     return {
  //       noReaders: isNoReadersSelected,
  //       selectedReaders: isSelectedReadersSelected,
  //       everyOneExceptSelected: isEveryOneExceptSelectedSelected,
  //     };
  //   });
  //   console.log(ref.current);
  //   let count = 0;

  //   selectReaders.map((reader) => {
  //     if (results.includes(reader)) {
  //       ref.current.map((element) => {
  //         if (element && reader === element.id) {
  //           element.checked = true;
  //           count++;
  //         }
  //       });
  //     }
  //   });
  //   if (count > 0 && count === results.length) {
  //     setSelectAll(true);
  //   }
  // }
  // }, [selectReaders]);

  useEffect(() => {
    let count = 0;
    console.log(results);

    selectedReaderInputRef.current.map((el) => {
      if (el) {
        el.checked = false;
        el.disabled = false;
      }
    });

    // pageSelection(
    //   prevSelectedPages.current,
    //   prevPagesToBeDisabledAnotherRestrictions
    // );

    checkReaders.current.forEach((reader, i) => {
      if (results.includes(reader)) {
        selectedReaderInputRef.current.map((el) => {
          if (el && el.id === reader) {
            el.checked = true;
          }
        });
      }
    });

    selectedReaderInputRef.current.map((el) => {
      if (el && el.checked) count++;
    });
    if (count > 0 && count === results.length) {
      selectAllRef.current.checked = true;
    } else {
      selectAllRef.current.checked = false;
    }
  }, [results]);

  useImperativeHandle(ref, () => {
    return {
      getSelectedReaders() {
        return [...checkReaders.current];
        // selectedReaderInputRef.current = selectedReaderInputRef.current.filter(
        //   (r) => r !== null && r.checked === true
        // );
        // const selectedReaders = selectedReaderInputRef.current
        //   .filter((element) => {
        //     if (selectedOption.noReaders) {
        //       return true;
        //     } else if (selectedOption.selectedReaders) {
        //       return element.checked;
        //     } else {
        //       return element.checked;
        //     }
        //   })
        //   .map((element) => element.id);
        // return selectedReaders;
      },
      checkSelectedReadersAndCategory(selectReaders, selectedCategory) {
        selectAllRef.current.checked = false;
        if (isEdits) {
          let isNoReadersSelected = false;
          let isSelectedReadersSelected = false;
          let isEveryOneExceptSelectedSelected = false;
          if (selectedCategory === "No Readers") {
            isNoReadersSelected = true;
            onShowAddReader(false, selectedCategory);
          } else if (selectedCategory === "Selected Readers") {
            isSelectedReadersSelected = true;
          } else {
            isEveryOneExceptSelectedSelected = true;
          }
          onShowAddReader(true, selectedCategory);
          setSelectedOption(() => {
            return {
              noReaders: isNoReadersSelected,
              selectedReaders: isSelectedReadersSelected,
              everyOneExceptSelected: isEveryOneExceptSelectedSelected,
            };
          });

          let count = 0;

          selectReaders.map((reader) => {
            if (results.includes(reader)) {
              selectedReaderInputRef.current.map((element) => {
                if (element && reader === element.id) {
                  element.checked = true;
                  count++;
                }
              });
            }
          });
          checkReaders.current = [...selectReaders];
          if (count > 0 && count === results.length) {
            selectAllRef.current.checked = true;
          }
        }
      },
    };
  });

  return (
    <>
      <Alert alertType={alertType} alertMsg={alertMsg} setAlertMsg={setAlertMsg} setAlertType={setAlertType}></Alert>
      <div className="col-sm-12 col-md-4 pagesCanbeAccessby">
        <div className="bg-lightblue readers-head">
          <h6 className="mb-0 f-w550 font-16 page-font">
            {selectedLanguage.LstLanguageCodes.UI_PagesCanbeAccessby}
          </h6>
        </div>
        <div className="d-flex flex-column ">
          <div className="radio mb-0 pageborder-bottom ps-2 pt-1">
            <input
              type="radio"
              id="noReaders"
              value="No Readers"
              checked={
                enableOptionsBasedOnLevelOne ? true : selectedOption.noReaders
              }
              onChange={() => {
                onShowAddReader(false, "No Readers");
                // setSelectAll(false);
                selectAllRef.current.checked = false;
                checkReaders.current = [];
                selectedReaderInputRef.current.map((element) => {
                  if (element) {
                    element.checked = false;
                  }
                });
                setSelectedOption((prev) => {
                  return {
                    everyOneExceptSelected: false,
                    selectedReaders: false,
                    noReaders: true,
                  };
                });
              }}
            />
            <label for="noReaders" className="radio-label colorBlack mb-1">
              {selectedLanguage.LstLanguageCodes.UI_NoReaders}
            </label>
          </div>

          <div className="radio my-0 pt-2 pageborder-bottom ps-2 pt-1">
            <input
              type="radio"
              id="selectedReaders"
              value="Selected Readers"
              checked={
                enableOptionsBasedOnLevelOne
                  ? false
                  : selectedOption.selectedReaders
              }
              onChange={() => {
                if (enableOptionsBasedOnLevelOne) return;
                onShowAddReader(true, "Selected Readers");

                setSelectedOption((prev) => {
                  return {
                    everyOneExceptSelected: false,
                    selectedReaders: true,
                    noReaders: false,
                  };
                });
              }}
            //disabled={enableOptionsBasedOnLevelOne}
            />
            <label
              for="selectedReaders"
              className={
                enableOptionsBasedOnLevelOne
                  ? "fadeOutLabelsTrackViews radio-label colorBlack mb-1"
                  : " radio-label colorBlack mb-1"
              }>
              {selectedLanguage.LstLanguageCodes.UI_SelectedReaders}
            </label>
          </div>

          <div className="radio my-0 ps-2 pt-2 pageborder-bottom">
            <input
              type="radio"
              id="everyoneExceptSelectedReaders"
              value="Everyone Except Selected Readers"
              checked={
                enableOptionsBasedOnLevelOne
                  ? false
                  : selectedOption.everyOneExceptSelected
              }
              onChange={() => {
                if (enableOptionsBasedOnLevelOne) return;
                onShowAddReader(true, "Everyone Except Selected Readers");
                setSelectedOption((prev) => {
                  return {
                    everyOneExceptSelected: true,
                    selectedReaders: false,
                    noReaders: false,
                  };
                });
              }}
            //disabled={enableOptionsBasedOnLevelOne}
            />
            <label
              for="everyoneExceptSelectedReaders"
              className={
                enableOptionsBasedOnLevelOne
                  ? "fadeOutLabelsTrackViews radio-label colorBlack mb-1"
                  : "radio-label colorBlack mb-1"
              }>
              {selectedLanguage.LstLanguageCodes.UI_EveryOneExceptSelected}
            </label>
          </div>

          {/* <div className="d-flex align-items-center pageborder-bottom colorBlack">
            <div className="checkbox pt-lg-1">
              <label
                className="ps-3 pl-0p noReadersRadio"
             >
                <input
                  className="small-radio"
                  style={{cursor:'pointer'}}
                  type="radio"
                  id="noReaders"
                  value="No Readers"
                  checked={
                    enableOptionsBasedOnLevelOne
                      ? true
                      : selectedOption.noReaders
                  }
                  onChange={() => {
                    onShowAddReader(false, "No Readers");
                    setSelectAll(false);
                    ref.current.map((element) => {
                      if (element) {
                        element.checked = false;
                      }
                    });
                    setSelectedOption((prev) => {
                      return {
                        everyOneExceptSelected: false,
                        selectedReaders: false,
                        noReaders: true,
                      };
                    });
                  }}
                />
                <span>{selectedLanguage.LstLanguageCodes.UI_NoReaders}</span>
              </label>
            </div>
          </div> */}
          {/* <div className="d-flex align-items-center pageborder-bottom colorBlack">
            <div className="checkbox pt-lg-1">
              <label
                className="ps-3 pl-0p selectedReadersRadio"
                disabled={enableOptionsBasedOnLevelOne}>
                <input
                  className="small-radio"
                  style={{ cursor: "pointer" }}
                  type="radio"
                  id="selectedReaders"
                  value="Selected Readers"
                  checked={
                    enableOptionsBasedOnLevelOne
                      ? false
                      : selectedOption.selectedReaders
                  }
                  onChange={() => {
                    onShowAddReader(true, "Selected Readers");

                    setSelectedOption((prev) => {
                      return {
                        everyOneExceptSelected: false,
                        selectedReaders: true,
                        noReaders: false,
                      };
                    });
                  }}
                  disabled={enableOptionsBasedOnLevelOne}
                />
                <span
                  className={
                    enableOptionsBasedOnLevelOne
                      ? "fadeOutLabelsTrackViews"
                      : ""
                  }>
                  {selectedLanguage.LstLanguageCodes.UI_SelectedReaders}
                </span>
              </label>
            </div>
          </div> */}
          {/* <div className="d-flex align-items-center colorBlack pageborder-bottom">
            <div className="checkbox pt-lg-1">
              <label
                className="ps-3 pl-0p d-flex selectedReadersRadio"
                disabled={enableOptionsBasedOnLevelOne}>
                <input
                  className="small-radio"
                  style={{ cursor: "pointer" }}
                  type="radio"
                  id="everyoneExceptSelectedReaders"
                  value="Everyone Except Selected Readers"
                  checked={
                    enableOptionsBasedOnLevelOne
                      ? false
                      : selectedOption.everyOneExceptSelected
                  }
                  onChange={() => {
                    onShowAddReader(true, "Everyone Except Selected Readers");
                    setSelectedOption((prev) => {
                      return {
                        everyOneExceptSelected: true,
                        selectedReaders: false,
                        noReaders: false,
                      };
                    });
                  }}
                  disabled={enableOptionsBasedOnLevelOne}
                />
                <span
                  className={
                    enableOptionsBasedOnLevelOne
                      ? "fadeOutLabelsTrackViews"
                      : ""
                  }>
                  {selectedLanguage.LstLanguageCodes.UI_EveryOneExceptSelected}
                </span>
              </label>
            </div>
          </div> */}
        </div>
      </div>
      <div
        className={`col-sm-12 col-md-4 readersListPopup ${!selectedOption.noReaders == false || enableOptionsBasedOnLevelOne
          ? "disabled-modal"
          : ""
          }`}>
        <div className="bg-lightblue readers-head ReadersListSticky">
          <h6 className="mb-0 f-w550 font-16 page-font">
            {selectedLanguage.LstLanguageCodes.UI_ReadersList}
          </h6>
          <span
            onClick={AddReaderClick}
            title={selectedLanguage.LstLanguageCodes.UI_AddReaderCaps}
            className="material-icons addReader">
            person_add
          </span>
        </div>
        <div
          className="search-container readersListSearchSticky d-flex"
        // style={{ position: "sticky", top: "35px", background: "white", zIndex: 10 }}
        >
          <div className="input-group custom-inputBorder d-flex align-items-center">
            <div className="input-group-text" id="basic-addon11">
              <div className="checkbox">
                <label className="pl-10px">
                  <input
                    className="form-check-input notLevelOne"
                    type="checkbox"
                    id="restrictions1"
                    value="Page level Restrictions"
                    ref={selectAllRef}
                    // checked={selectAll}
                    onChange={handleSelectAll}
                  />
                  <span className="cr">
                    <i className="cr-icon material-icons">check</i>
                  </span>
                </label>
                <label className="mb-0">
                  {" "}
                  {selectedLanguage.LstLanguageCodes.UI_SelectAll}
                </label>
              </div>
            </div>
            <input
              type="search"
              className="form-control"
              aria-label="Username"
              aria-describedby="basic-addon11"
              placeholder={`${selectedLanguage.LstLanguageCodes.UI_Search}...`}
              onChange={onSearchHandler}
              style={{
                boxShadow: "none",
                padding: "8.5px 2px 8px 32px",
                border: "none !important",
              }}
            />
          </div>
          {/* <div className="d-flex align-items-center w-50 pageborder-bottom-b">
            <div className="checkbox pt-2 ml-3">
              <label className="ps-3 pl-0p">
                <input
                  className="form-check-input notLevelOne"
                  type="checkbox"
                  id="restrictions1"
                  value="Page level Restrictions"
                  checked={selectAll}
                  onChange={handleSelectAll}
                />
                <span className="cr" tabIndex="14">
                  <i className="cr-icon material-icons">check</i>
                </span>
              </label>
            </div>
            <label className="mb-0 colorBlack">
              {selectedLanguage.LstLanguageCodes.UI_SelectAll}
            </label>
          </div>
          <input
            type="search"
            className="SearchFiels w-50"
            placeholder={`${selectedLanguage.LstLanguageCodes.UI_Search}...`}
            onChange={onSearchHandler}
            style={{
              boxShadow: "none",
              padding: "8.5px 2px 8px 25px",
              border: "1px solid #e8e6e6",
            }}
          /> */}
        </div>
        <div className="scrollable-content scrollable-content-r">
          {results.map((reader, i) => (
            <div
              className="d-flex align-items-center pageborder-bottom pl-8p"
              key={i}>
              <div className="checkbox pt-2 ml-3">
                <label
                  className="ps-3 pl-0p"
                  style={{ wordBreak: "break-all" }}>
                  <input
                    type="checkbox"
                    textContent={reader}
                    id={reader}
                    ref={(el) => (selectedReaderInputRef.current[i] = el)}
                    onChange={handleSelectReader}
                  />
                  <span className="cr" tabIndex="14">
                    <i className="cr-icon material-icons">check</i>
                  </span>
                </label>
              </div>
              {reader !== "" && (
                <label className="mb-0 colorBlack label-wrap">{reader}</label>
              )}
              {reader === "" && (
                <input
                  className="w-100"
                  style={{ border: "none", boxShadow: "none" }}
                  ref={addReaderRef}
                  onKeyDown={handleUserInput}
                />
              )}
            </div>
          ))}
          {addReader && (
            <div
              className="d-flex align-items-center pageborder-bottom"
              style={{ position: "relative" }}>
              <input
                className="w-100 addReaderField"
                placeholder="Email"
                ref={addReaderRef}
                onKeyDown={handleUserInput}
              />
              <span
                className="material-icons alignIcons enterIcon"
                onClick={EnterClick}
                title="Confirm">
                check_circle
              </span>
              <span
                className="material-icons cancelIcon"
                onClick={CancelClick}
                title="Cancel">
                cancel
              </span>
            </div>
          )}
        </div>
      </div>
    </>
  );
});

export default Readers;
